module.exports = __webpack_public_path__ + "img/ssbg3.22ac4632.jpg";